export default "/static/webpack/media/undraw_football_cards.3e44081f.svg";